/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, Divider, Icon, Paper, Skeleton, Theme, Typography, useMediaQuery, useTheme } from '@mui/material';

interface IFerramentasDeDetalheProps {
  textoBotaoNovo?: string;
  mostrarBotaoNovo?: boolean;
  mostrarBotaoVoltar?: boolean;
  mostrarBotaoApagar?: boolean;
  mostrarBotaoSalvar?: boolean;
  mostrarBotaoSalvarEFechar?: boolean;
  mostrarBotaoImpressao?: boolean;
  mostrarBotaoDevolucao?: boolean;
  mostrarBotaoDevolucaoCarregando?: boolean;
  mostrarBotaoCancelarVendaCarregando?: boolean;
  mostrarBotaoCancelarVenda?: boolean;

  disableBotaoDevolucao?: boolean;
  disableBotaoSalvar?: boolean;
  disableBotaoSalvarEFechar?: boolean;
  disableBotaoApagar?: boolean;
  disableBotaoCancelarVenda?: boolean;

  mostrarBotaoNovoCarregando?: boolean;
  mostrarBotaoVoltarCarregando?: boolean;
  mostrarBotaoApagarCarregando?: boolean;
  mostrarBotaoSalvarCarregando?: boolean;
  mostrarBotaoSalvarEFecharCarregando?: boolean;
  mostrarBotaoImpressaoCarregando?: boolean;

  aoClicarEmNovo?: () => void;
  aoClicarEmVoltar?: () => void;
  aoClicarEmApagar?: () => void;
  aoClicarEmSalvar?: () => void;
  aoClicarEmSalvarEFechar?: () => void;
  aoClicarEmImpressao?: () => void;
  aoClicarEmDevolucao?: () => void;
  aoClicarEmCancelarVenda?: () => void;
}
export const FerramentasDeDetalheVenda: React.FC<IFerramentasDeDetalheProps> = ({
  textoBotaoNovo = 'Novo',
  mostrarBotaoNovo = true,
  mostrarBotaoVoltar = true,
  mostrarBotaoApagar = true,
  mostrarBotaoSalvar = true,
  mostrarBotaoImpressao = true,
  mostrarBotaoCancelarVenda = false,
  disableBotaoSalvar = false,
  disableBotaoDevolucao = true,
  disableBotaoSalvarEFechar = false,
  disableBotaoApagar = false,
  disableBotaoCancelarVenda = true,
  mostrarBotaoSalvarEFechar = false,
  mostrarBotaoNovoCarregando = false,
  mostrarBotaoVoltarCarregando = false,
  mostrarBotaoCancelarVendaCarregando = false,
  mostrarBotaoApagarCarregando = false,
  mostrarBotaoSalvarCarregando = false,
  mostrarBotaoSalvarEFecharCarregando = false,
  mostrarBotaoImpressaoCarregando = false,
  mostrarBotaoDevolucao = false,
  mostrarBotaoDevolucaoCarregando = false,

  aoClicarEmDevolucao,
  aoClicarEmNovo,
  aoClicarEmVoltar,
  aoClicarEmApagar,
  aoClicarEmSalvar,
  aoClicarEmSalvarEFechar,
  aoClicarEmImpressao,
  aoClicarEmCancelarVenda,
}) => {
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const shortScreen = useMediaQuery('(max-height:700px)');
  const theme = useTheme();
  const tamanhoBotao = shortScreen ? 'small' : 'medium';

  return (
    <Box
      gap={shortScreen ? 0.5 : 1}
      marginX={2}
      padding={shortScreen ? 0.5 : 1}
      paddingX={2}
      display="flex"
      flexWrap="wrap"
      alignItems="center"
      minHeight={theme.spacing(shortScreen ? 5 : 6)}
      component={Paper}
    >
      {(mostrarBotaoVoltar && !mostrarBotaoVoltarCarregando) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          size={tamanhoBotao}
          onClick={aoClicarEmVoltar}
          startIcon={<Icon>arrow_back</Icon>}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            (ESC)Voltar
          </Typography>
        </Button>
      )}

      {mostrarBotaoVoltarCarregando && (
        <Skeleton width={110} height={shortScreen ? 40 : 60} />
      )}
      {
        (
          mostrarBotaoVoltar &&
          (mostrarBotaoNovo || mostrarBotaoApagar || mostrarBotaoSalvar || mostrarBotaoSalvarEFechar)
        ) && (
          <Divider variant='middle' orientation='vertical' />
        )
      }

      {(mostrarBotaoSalvar && !mostrarBotaoSalvarCarregando) && (
        <Button
          color='primary'
          disableElevation
          disabled={disableBotaoSalvar}
          variant='contained'
          size={tamanhoBotao}
          onClick={aoClicarEmSalvar}
          startIcon={<Icon>save</Icon>}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            (F4) Salvar
          </Typography>
        </Button>
      )}

      {mostrarBotaoSalvarCarregando && (
        <Skeleton width={110} height={shortScreen ? 40 : 60} />
      )}

      {(mostrarBotaoSalvarEFechar && !mostrarBotaoSalvarEFecharCarregando && !smDown && !mdDown) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          size={tamanhoBotao}
          disabled={disableBotaoSalvarEFechar}
          onClick={aoClicarEmSalvarEFechar}
          startIcon={<Icon>save</Icon>}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            Salvar e Fechar
          </Typography>
        </Button>
      )}

      {(mostrarBotaoSalvarEFecharCarregando && !smDown && !mdDown) && (
        <Skeleton width={180} height={shortScreen ? 40 : 60} />
      )}

      {(mostrarBotaoApagar && !mostrarBotaoApagarCarregando) && (
        <Button
          color='error'
          disableElevation
          variant='contained'
          size={tamanhoBotao}
          onClick={aoClicarEmApagar}
          disabled={disableBotaoApagar}
          startIcon={<Icon>delete</Icon>}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            Apagar
          </Typography>
        </Button>
      )}

      {mostrarBotaoApagarCarregando && (
        <Skeleton width={110} height={shortScreen ? 40 : 60} />
      )}

      {(mostrarBotaoNovo && !mostrarBotaoNovoCarregando && !smDown) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          size={tamanhoBotao}
          onClick={aoClicarEmNovo}
          startIcon={<Icon>add</Icon>}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            (F2){textoBotaoNovo}
          </Typography>
        </Button>
      )}

      {(mostrarBotaoNovoCarregando && !smDown) && (
        <Skeleton width={110} height={shortScreen ? 40 : 60} />
      )}

      {(mostrarBotaoImpressao && !mostrarBotaoImpressaoCarregando) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          size={tamanhoBotao}
          onClick={aoClicarEmImpressao}
          startIcon={<Icon>printoutlined</Icon>}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            (F10)Imprimir
          </Typography>
        </Button>
      )}
      {(mostrarBotaoDevolucao && !mostrarBotaoDevolucaoCarregando) && (
        <Button
          color='warning'
          disableElevation
          variant='contained'
          size={tamanhoBotao}
          onClick={aoClicarEmDevolucao}
          disabled={disableBotaoDevolucao}
          startIcon={<Icon>assignment_return</Icon>}
        >
          <Typography
            variant='button'
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
          >
            Devolução
          </Typography>
        </Button>
      )}
      {(mostrarBotaoCancelarVenda && !mostrarBotaoCancelarVendaCarregando) && (
        <Button
          color="error"
          variant="outlined"
          disableElevation
          size={tamanhoBotao}
          disabled={disableBotaoCancelarVenda}
          onClick={aoClicarEmCancelarVenda}
          startIcon={<Icon>cancel</Icon>}
        >
          <Typography variant="button">
            Cancelar Venda
          </Typography>
        </Button>
      )}

      {mostrarBotaoCancelarVendaCarregando && (
        <Skeleton width={150} height={shortScreen ? 40 : 60} />
      )}

      {mostrarBotaoDevolucaoCarregando && (
        <Skeleton width={130} height={shortScreen ? 40 : 60} />
      )}


    </Box >
  );
};